export default "__VITE_ASSET__1233759d__"